import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { AccountService } from '../../../@resources/services/account.service';
import { SettingService } from '../../../@resources/services/setting.service';
import { ServiceService } from '../../../@resources/services/service.service';
import { LocalStorageService } from '../../../@resources/services/local-storage.service';
import { Global } from '../../../@core/global/global';
import { MatDialog } from '@angular/material/dialog';
import { PaginationOptions } from '../../../@resources/graphql/types/types';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AuthDialogComponent } from '../auth-dialog/auth-dialog.component';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnInit {
  @Output() sidenavClose = new EventEmitter();

  currentLang: any;
  paginationOptions: PaginationOptions = { limit: 4, page: 1 };

  @Output() public sidenavToggle = new EventEmitter();

  constructor(
    public dialog: MatDialog,
    public global: Global,
    private serviceService: ServiceService,
    private localStorage: LocalStorageService,
    @Inject(DOCUMENT) private _document: Document,
    private translate: TranslateService,
    private settingService: SettingService,
    private accountService: AccountService
  ) {
    this.switchLang(
      this.localStorage.get('lang') ? this.localStorage.get('lang') : 'ar'
    );
  }

  ngOnInit(): void {
    this.getLang();
    this.listService();
    this.listSetting();
    if (this.localStorage.get('TOKEN')) {
      this.customer();
      this.global.authenticated = true;
    } else {
      this.global.authenticated = false;
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(AuthDialogComponent, {});
  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  };

  listService() {
    this.serviceService
      .listServices(this.paginationOptions)
      .subscribe((res: any) => {
        this.global.services = res.data.services;
      });
  }
  listSetting() {
    this.settingService.listSetting().subscribe(({ data }) => {
      this.global.setting = data['setting'];
    });
  }
  changeLang(lang: any) {
    this.localStorage.remove('lang');
    this.localStorage.set('lang', lang);
    this.global.lang = lang;
    this.refreshPage();
  }

  getLang() {
    if (this.localStorage.get('lang')) {
      this.currentLang = this.localStorage.get('lang');
    } else {
      this.currentLang = 'ar';
      this.localStorage.set('lang', 'ar');
    }
  }

  refreshPage() {
    this._document.defaultView!.location.reload();
  }

  switchLang(lang: string) {
    this.translate.use(lang);
    this.global.lang = lang;
  }

  customer() {
    this.accountService.listCustomer().subscribe(({ data }) => {
      this.global.customer = data?.customer;
    });
  }
  public onSidenavClose = () => {
    this.sidenavClose.emit();
  };
}
